export default __webpack_public_path__ + "static/media/kitchen4-afterF-2048w.c9dfafe7.avif";